import type { TablerIconsProps } from '@tabler/icons-react';

function CustomFilterIcon({
	size,
	color,
	...rest
}: Omit<TablerIconsProps, 'stroke'>) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			stroke={color ?? 'currentColor'}
			{...rest}
		>
			<path
				d="M2 6H22M5 12H19M8 18H16"
				stroke={color ?? 'currentColor'}
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

export default CustomFilterIcon;
